/*
 *   File : slider.js
 *   Author : https://evoqins.com
 *   Description : Custom slider component
 *   Integrations : react-slider
 *   Version : 1.0.0
*/

import { useEffect, useState } from "react";
import ReactSlider from "react-slider";

const CustomSlider = (props) => {

    const [sliderValue, setSliderValue] = useState(props.defaultValue);

    useEffect(() => {
        setSliderValue(props.defaultValue);
    }, [props.defaultValue]);

    // slider change function
    function _handleSliderChange(value) {
        props.handleChange(value);
    };

    // slider track click function
    function _handleSliderClick(value) {
        props.handleChange(value);
    };

    // rendering custom track
    function Track(props) {
        return (
            <div {...props}></div>
        )
    };

    // rendering custom thumb
    function Thumb(default_props) {
        return (
            props.hasTooltip ?
                <div {...default_props} className="position-relative no-outline">
                    <div className="slider-thumb">
                        <span className="slider-tooltip px-2 py-1 border-radius-8 e-bg-ocean-blue e-text-white e-alt-font-lato e-font-weight-600 e-font-12 line-height-16px e-letter-spacing-min-point-2px">
                            {/* Range */}
                            {props.toolTipValue}
                        </span>
                    </div>
                </div>
                :
                <div {...default_props}></div>
        )
    };

    return (
        props.type == 2 ?
            <div className={props.wrapperClassName}>
                <ReactSlider
                    value={sliderValue}
                    max={props.max}
                    min={props.min}
                    step={props.step}
                    className={props.className}
                    thumbClassName="slider-thumb"
                    trackClassName="slider-track"
                    renderTrack={Track}
                    renderThumb={Thumb}
                    disabled={props.disabled || false}
                    onChange={_handleSliderChange}
                />
                <div className='d-flex justify-content-between mt-2'>
                    <p className='mb-0 e-text-outer-space e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                        {props.minLabel}
                    </p>
                    <p className='mb-0 e-text-outer-space e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                        {props.maxLabel}
                    </p>
                </div>
            </div>
            :
            <div className="h-14">
                <ReactSlider
                    defaultValue={props.defaultValue}
                    minDistance={10}
                    className={props.className}
                    thumbClassName={`${props.thumbClassName}  cursor-pointer no-outline e-slider-thumb-shadow`}
                    trackClassName="cursor-pointer border-radius-8 h-4 slider-track"
                    renderTrack={Track}
                    renderThumb={Thumb}
                    onChange={_handleSliderChange}
                    onSliderClick={_handleSliderClick}
                />
            </div>
    )
};

export default CustomSlider;